import React, { useMemo } from "react";
import { useViewport } from 'components/general/useViewPort'
import LoaderSubComponent from "components/general/LoaderSubComponent";
//General
import Status from "components/presentation/Status";
import { isStartListStatus, isLiveStatus, isFinishedStatus } from "helpers/status";
import MirsTable from "components/general/table/Table";
import CaptionTable from "components/general/table/CaptionTable";
import TableColumns from 'components/sports/arc/events/Columns';
import TableExpanded from 'components/sports/arc/events/TableExpanded';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import Label from "components/general/Label";

const getConfiguration = (data, rsc, resultStatus, caption) => {
  const isStartList = isStartListStatus(resultStatus)
  const isLive = isLiveStatus(resultStatus)
  const isFinished = isFinishedStatus(resultStatus)

  let configuration = {
    caption: null,
    columns: [],
    //subComponent: null,
    hiddenColumns: ['StartOrder'],
    sortBy: [],
    filters: {
      ei_type: ['NONE'],
      ei_code: ['NONE']
    },
    configs: {
      isStartList: isStartList,
    }
  };

  configuration.sortBy = isStartList
    ? [{ id: 'Target', desc: false }]
    : [{ id: 'Rank', desc: false }]


  configuration.filters = {
    ei_type: ['DISPLAY'],
    ei_code: ['INTERMEDIATE_CURRENT']
  };

  configuration.columns = TableColumns()


  if (isStartList) {
    configuration.hiddenColumns = ['Rank', 'StartOrder']
  } else if (isFinished) {
    configuration.hiddenColumns = ['Target', 'StartOrder']
  }



  return configuration;
};

const ArcResultsIndividual = ({ data, caption }) => {
  const { mirs_rsc } = useUrlFriendlyToParameters()
  const { breakPoint } = useViewport();
  const resultStatus = data?.results?.status?.code;
  const configEvent = useMemo(() => getConfiguration(data, mirs_rsc, resultStatus, caption), [resultStatus, mirs_rsc]);
  const renderRowSubComponent = React.useCallback(({ row }) => {
    const componentExpanded = <TableExpanded row={row?.original} config={data?.results?.extendedInfos} />
    return (
      <LoaderSubComponent component={componentExpanded} />
    )
    // eslint-disable-next-line
  }, [resultStatus]);



  let moreCaption;
  let arrows = data?.results?.extendedInfos?.find(row => row.ei_code === 'ARROW_NUM');
  let arrowsTotal = arrows?.ei_value;
  let current = arrows?.extensions?.find(row => row.eie_code === 'CURRENT').eie_value;
  if (isLiveStatus(resultStatus)) {
    moreCaption = <>
      - <Label data="LabelArrowsShot" /> {current} / {arrowsTotal}
    </>
  }
  let tableCaption = <CaptionTable
    leftCol={<>{caption} {moreCaption}</>}
    rightCol={<Status typeToPrint={'result'} scheduleStatus={data?.results?.schedule?.status?.code} resultStatus={data?.results?.status?.code} />}
  />

  return (
    <>
      {data?.results ? (
        <>
          {data?.results?.items ? (
            < MirsTable
              className='table-result'
              //Dato to show by row
              data={data?.results?.items}
              //Columnas a visualizar 
              columns={configEvent.columns}
              //subcomponente a renderizar, extended
              renderRowSubComponent={renderRowSubComponent}
              //pageSizeCustom={data.items.length} //ponerlo por defecto en el componente                             
              //Key by row necesary in order to no paint innecesary
              keyRow='participant-code'
              //Component caption
              caption={tableCaption}
              //Columns to hidde 
              hiddenColumns={configEvent.hiddenColumns}
              //When show tble is sorted by 
              initialSortBy={configEvent.sortBy}
              //Show buttons move to splits 
              showNavExtendedData={true}
              id={`mirs-table-result-${mirs_rsc}`}
              hasRelatedTimeline={true}
            />
          ) : ('')
          }
        </>
      ) : (
        <span><em>No data available</em></span>
      )
      }
    </>
  );
};


export default ArcResultsIndividual;